import { Tab } from "@headlessui/react";
import clsx from "clsx";
import { ReactNode } from "react";
import { useFormContext } from "react-hook-form";

import { direTabClassName } from "@/components/Interface/TabWithDisableHint/TabWithDisableHint";
import { FocusRing } from "@/components/Layout/BaseLayouts/Footer/FocusRing";

export interface RateTypeTabsProps {
  selectedIndex: number;
  onIndexChange: (index: number) => void;
  listClassName?: string;
  disabled?: boolean;
  firstLabel: string;
  secondLabel: string;
  /** When set, renders a third tab (partner Flat Home). Omit on customer flows. */
  thirdLabel?: string;
  hideSecondTab?: boolean;
  children: ReactNode;
}

export const RateTypeTabs = ({
  selectedIndex,
  onIndexChange,
  listClassName,
  disabled = false,
  firstLabel,
  secondLabel,
  thirdLabel,
  hideSecondTab = false,
  children,
}: RateTypeTabsProps) => {
  const { reset } = useFormContext();

  const handleChange = (nextIndex: number) => {
    if (disabled) {
      return;
    }

    onIndexChange(nextIndex);
    reset();
  };

  const tabLabels = thirdLabel
    ? [firstLabel, secondLabel, thirdLabel]
    : [firstLabel, secondLabel];

  if (hideSecondTab) {
    return (
      <Tab.Group selectedIndex={0} onChange={() => undefined}>
        {children}
      </Tab.Group>
    );
  }

  return (
    <Tab.Group selectedIndex={selectedIndex} onChange={handleChange}>
      <Tab.List
        className={clsx("flex gap-2", disabled && "opacity-50", listClassName)}
      >
        {tabLabels.map((label) => (
          <Tab
            key={label}
            disabled={disabled}
            className={({ selected }) =>
              clsx(
                direTabClassName,
                "text-foreground-primary transition-colors hover:bg-surface-secondary",
                selected && "bg-surface-tertiary",
              )
            }
          >
            <FocusRing />
            {/* Optical baseline centering for Gellix, as on the DS button. */}
            <span className="pb-1">{label}</span>
          </Tab>
        ))}
      </Tab.List>
      {children}
    </Tab.Group>
  );
};
